import React, { Component } from 'react';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { Card } from 'primereact/card';
import { Toast } from 'primereact/toast';
import { Skeleton } from 'primereact/skeleton';
// import './PromotionModuleSelection.css';

class PromotionModuleSelection extends Component {
    constructor(props) {
        super(props);

        //console.log('=== PROMOTION MODULE SELECTION INITIALIZATION ===');
        //console.log('Props received:', props);
        //console.log('Promotion data:', props.promotionData);
        //console.log('Data payload from screen 1:', props.promotionData?.data);

        // Initialize branch-specific module selections from the "data" payload
        const branchModuleSelections = this.initializeBranchModuleSelections();

        //console.log('Initialized branch module selections:', branchModuleSelections);

        this.state = {
            branchModuleSelections,
            targetAcademicYear: props.promotionData?.data?.targetAcademicYear || props.promotionData?.targetAcademicYear || props.promotionData?.academicYear || '',
            dataPayload: props.promotionData?.data || {},
            isLoading: false
        };

        this.toast = React.createRef();
    }

    // Helper method to check if user has made any previous selections
    hasUserMadePreviousSelections = () => {
        const { promotionData } = this.props;
        const existingSelections = promotionData?.branchModuleSelections || {};

        // Check if there are any existing branch module selections
        const hasExistingSelections = Object.keys(existingSelections).length > 0;

        // Check if this is coming from navigation history (user has been to this screen before)
        const hasNavigationHistory = promotionData?.navigationHistory &&
            promotionData.navigationHistory.includes('module-selection');

        // Check if there's a timestamp indicating previous modifications
        const hasBeenModified = promotionData?.lastModified || promotionData?.preservedAt;

        //console.log('=== CHECKING USER SELECTION HISTORY ===');
        //console.log('Has existing selections:', hasExistingSelections);
        //console.log('Has navigation history:', hasNavigationHistory);
        //console.log('Has been modified:', !!hasBeenModified);

        return hasExistingSelections || hasNavigationHistory || !!hasBeenModified;
    }

    // Enhanced initialization to preserve existing selections
    initializeBranchModuleSelections = () => {
        const { promotionData } = this.props;
        const dataPayload = promotionData?.data || {};
        const existingSelections = promotionData?.branchModuleSelections || {};

        // Check if user has made selections before
        const userHasPreviousSelections = this.hasUserMadePreviousSelections();

        //console.log('=== INITIALIZING MODULE SELECTIONS ===');
        //console.log('User has previous selections:', userHasPreviousSelections);
        //console.log('Existing selections from previous navigation:', existingSelections);
        //console.log('Data payload branches:', dataPayload.branches);

        const branchModuleSelections = {};

        // Initialize module selections based on the hierarchical data structure
        if (dataPayload.branches) {
            dataPayload.branches.forEach(branch => {
                //console.log(`Initializing modules for branch: ${branch.branchName} (${branch.branchId})`);

                // Check if we have existing selections for this branch (preserved from previous navigation)
                const existingBranchSelections = existingSelections[branch.branchId] || {};

                // Check if branch has existing modules from data or previous selections
                const existingModules = branch.modules || [];
                const existingModuleSelections = branch.moduleSelections || {};

                //console.log(`Existing modules for ${branch.branchName}:`, existingModules);
                //console.log(`Existing selections for ${branch.branchName}:`, existingBranchSelections);
                //console.log(`Module selections from data:`, existingModuleSelections);

                branchModuleSelections[branch.branchId] = {
                    // These are always enabled and cannot be disabled
                    admissions: this.getPreservedSelection(
                        existingBranchSelections,
                        existingModuleSelections,
                        'admissions',
                        true, // always has existing data (mandatory)
                        true  // always default to true
                    ),
                    financeGeneralSettings: this.getPreservedSelection(
                        existingBranchSelections,
                        existingModuleSelections,
                        'financeGeneralSettings',
                        true, // always has existing data (mandatory)
                        true  // always default to true
                    ),

                    // These can be toggled based on existing data, previous selections, or defaults
                    feeSetup: this.getPreservedSelection(
                        existingBranchSelections,
                        existingModuleSelections,
                        'feeSetup',
                        existingModules.includes('Fee SetUp') || existingModules.includes('Fee Setup'),
                        userHasPreviousSelections ? false : true // If user has selections, preserve them; else default to true
                    ),
                    finance: this.getPreservedSelection(
                        existingBranchSelections,
                        existingModuleSelections,
                        'finance',
                        existingModules.includes('Finance'),
                        userHasPreviousSelections ? false : true // If user has selections, preserve them; else default to true
                    ),
                    // transport: this.getPreservedSelection(
                    //     existingBranchSelections,
                    //     existingModuleSelections,
                    //     'transport',
                    //     existingModules.includes('Transport') || true
                    // ),

                    // Store the branch metadata
                    branchName: branch.branchName,
                    boardCount: branch.boardCount,
                    hasBoards: branch.boards && branch.boards.length > 0
                };

                //console.log(`Final selections for ${branch.branchName}:`, branchModuleSelections[branch.branchId]);
                //console.log(`User has previous selections: ${userHasPreviousSelections} - Applied defaults accordingly`);
            });
        }

        //console.log('=== FINAL BRANCH MODULE SELECTIONS ===');
        //console.log('User selection mode:', userHasPreviousSelections ? 'PRESERVE_DESELECTIONS' : 'DEFAULT_ALL_SELECTED');
        //console.log('Final selections:', branchModuleSelections);

        return branchModuleSelections;
    }

    // Helper method to get preserved selection with priority order
    getPreservedSelection = (existingBranchSelections, existingModuleSelections, moduleKey, hasExistingData, defaultValue = true) => {
        // Priority order:
        // 1. Existing branch selections (from previous navigation) - PRESERVE USER DESELECTIONS
        // 2. Module selections from data payload - if user has previously interacted
        // 3. Default value (true for first-time users, preserves deselections for returning users)

        // If user has made explicit selections before (either true or false), preserve them
        if (existingBranchSelections.hasOwnProperty(moduleKey)) {
            //console.log(`Using preserved selection for ${moduleKey}:`, existingBranchSelections[moduleKey]);
            return existingBranchSelections[moduleKey];
        }

        // If data payload has explicit selections (user has interacted before), use them
        if (existingModuleSelections.hasOwnProperty(moduleKey)) {
            //console.log(`Using data payload selection for ${moduleKey}:`, existingModuleSelections[moduleKey]);
            return existingModuleSelections[moduleKey];
        }

        // For first-time users or when no previous selections exist:
        // - If module exists in the system data, keep it selected
        // - Otherwise, use the provided default value (usually true for optional modules)
        const finalValue = hasExistingData || defaultValue;
        //console.log(`Using default value for ${moduleKey} (hasExistingData: ${hasExistingData}, defaultValue: ${defaultValue}):`, finalValue);
        return finalValue;
    }

    componentDidMount() {
        // Initial setup
        console.log("PromotionModuleSelection mounted Rerendered");
        // const isErrorNavigation = this.props.promotionData?.errorNavigation || 
        //                             this.props.promotionData?.navigationHistory?.includes('error-from-preview');

        //     if (isErrorNavigation) {
        //         //console.log('=== ERROR NAVIGATION DETECTED - AUTO TRIGGERING BACK ===');
        //         // Automatically trigger back navigation to go to main Promotions
        //         setTimeout(() => {
        //             this.handleBack();
        //         }, 100); // Small delay to ensure component is ready
        //         return;
        //     }
        // this.componentDidUpdate();
    }

    componentDidUpdate(prevProps) {
        // Handle props changes when navigating back from other screens
        if (prevProps.promotionData !== this.props.promotionData) {
            //console.log('=== PROMOTION DATA UPDATED - PRESERVING SELECTIONS ===');
            //console.log('Previous promotion data:', prevProps.promotionData);
            //console.log('New promotion data:', this.props.promotionData);

            const isErrorNavigation = this.props.promotionData?.errorNavigation ||
                this.props.promotionData?.navigationHistory?.includes('error-from-preview');

            if (isErrorNavigation) {
                //console.log('=== ERROR NAVIGATION DETECTED - AUTO TRIGGERING BACK ===');
                // Automatically trigger back navigation to go to main Promotions
                setTimeout(() => {
                    this.handleBack();
                }, 100); // Small delay to ensure component is ready
                return;
            }

            // Re-initialize selections to preserve any updates
            const updatedSelections = this.initializeBranchModuleSelections();

            this.setState({
                branchModuleSelections: updatedSelections,
                dataPayload: this.props.promotionData?.data || {},
                targetAcademicYear: this.props.promotionData?.data?.targetAcademicYear ||
                    this.props.promotionData?.targetAcademicYear ||
                    this.props.promotionData?.academicYear || this.state.targetAcademicYear
            });
        }
    }

    onModuleChange = (branchId, module, checked) => {
        // Prevent unchecking required modules but allow them to be checked
        if ((module === 'admissions' || module === 'financeGeneralSettings') && !checked) {
            this.showWarn('This module is mandatory and cannot be disabled');
            return;
        }

        //console.log(`Module change: ${module} = ${checked} for branch ${branchId}`);

        this.setState(prevState => ({
            branchModuleSelections: {
                ...prevState.branchModuleSelections,
                [branchId]: {
                    ...prevState.branchModuleSelections[branchId],
                    [module]: checked
                }
            }
        }), () => {
            //console.log('Updated branch module selections:', this.state.branchModuleSelections);

            // Auto-save selections to preserve them
            this.saveSelectionsToPromotionData();
        });
    }

    // Method to save current selections to promotion data for preservation
    saveSelectionsToPromotionData = () => {
        const { branchModuleSelections } = this.state;
        const { promotionData } = this.props;

        // Create updated promotion data with current selections
        const updatedPromotionData = {
            ...promotionData,
            branchModuleSelections: { ...branchModuleSelections },
            lastModified: new Date().toISOString()
        };

        //console.log('Auto-saving selections to promotion data:', updatedPromotionData.branchModuleSelections);

        // If there's a callback to update parent state, use it
        if (this.props.onSelectionChange) {
            this.props.onSelectionChange(updatedPromotionData);
        }
    }

    onTargetYearChange = (year) => {
        this.setState({ targetAcademicYear: year }, () => {
            // Save target year change as well
            this.saveSelectionsToPromotionData();
        });
    }

    // Helper method to map internal module keys to display names
    getModuleDisplayName = (moduleKey) => {
        const moduleMapping = {
            'admissions': 'Admissions',
            'financeGeneralSettings': 'Finance General Settings',
            'feeSetup': 'Fee SetUp',
            'finance': 'Finance',
            // 'transport': 'Transport'
        };
        return moduleMapping[moduleKey] || moduleKey;
    }

    // Method to create the enhanced hierarchical payload with modules
    createEnhancedDataPayload = () => {
        const { dataPayload, branchModuleSelections } = this.state;

        //console.log('=== CREATING ENHANCED DATA PAYLOAD WITH MODULES ===');
        //console.log('Current branch module selections:', branchModuleSelections);

        const enhancedPayload = {
            ...dataPayload,
            branches: dataPayload.branches.map(branch => {
                const branchModules = branchModuleSelections[branch.branchId];

                // Create modules array based on selected modules
                const selectedModules = [];
                Object.keys(branchModules).forEach(moduleKey => {
                    if (branchModules[moduleKey] === true &&
                        !['branchName', 'boardCount', 'hasBoards'].includes(moduleKey)) {
                        selectedModules.push(this.getModuleDisplayName(moduleKey));
                    }
                });

                //console.log(`Branch ${branch.branchName} selected modules:`, selectedModules);

                return {
                    ...branch,
                    modules: selectedModules,
                    moduleSelections: {
                        admissions: branchModules.admissions,
                        financeGeneralSettings: branchModules.financeGeneralSettings,
                        feeSetup: branchModules.feeSetup,
                        finance: branchModules.finance,
                        // transport: branchModules.transport
                    },
                    moduleFlags: {
                        // Add these flags for easy checking in PromotionPreview
                        showFeeSchedule: branchModules.feeSetup === true,
                        // showTransport: branchModules.transport === true,
                        showAdmissions: branchModules.admissions === true,
                        showFinance: branchModules.finance === true,
                        showFinanceGeneralSettings: branchModules.financeGeneralSettings === true
                    },
                    moduleMetadata: {
                        totalModulesSelected: selectedModules.length,
                        mandatoryModules: ['Admissions', 'Finance General Settings'],
                        optionalModules: selectedModules.filter(m =>
                            !['Admissions', 'Finance General Settings'].includes(m)
                        ),
                        lastUpdated: new Date().toISOString(),
                        preservedSelections: true
                    }
                };
            }),
            selectionHistory: {
                lastModified: new Date().toISOString(),
                preservedFromNavigation: true
            }
        };

        //console.log('Enhanced data payload with preserved modules:', JSON.stringify(enhancedPayload, null, 2));
        return enhancedPayload;
    }

    handleNext = () => {
        //console.log('=== HANDLING NEXT - MODULE SELECTION COMPLETE (WITH PRESERVATION) ===');

        // Set loading state
        this.setState({ isLoading: true });

        // Simulate processing time for shimmer effect
        setTimeout(() => {
            const { branchModuleSelections, targetAcademicYear } = this.state;
            const { promotionData } = this.props;

            // Create the enhanced data payload with module selections
            const enhancedDataPayload = this.createEnhancedDataPayload();

            const finalPromotionData = {
                ...promotionData,
                targetAcademicYear,
                branchModuleSelections: { ...branchModuleSelections }, // Deep copy to preserve selections
                data: enhancedDataPayload, // Updated data payload with module selections
                // Create a summary of all selected modules across branches
                allSelectedModules: this.getAllSelectedModules(),
                moduleSelectionMetadata: {
                    totalBranches: Object.keys(branchModuleSelections).length,
                    completedAt: new Date().toISOString(),
                    branchModuleSummary: this.getBranchModuleSummary(),
                    preservedSelections: true,
                    navigationHistory: (promotionData.navigationHistory || []).concat(['module-selection'])
                }
            };

            //console.log('=== FINAL PROMOTION DATA WITH PRESERVED BRANCH-SPECIFIC MODULES ===');
            //console.log('Final promotion data:', JSON.stringify(finalPromotionData, null, 2));

            // Log the enhanced data structure for verification
            //console.log('=== ENHANCED DATA PAYLOAD STRUCTURE (PRESERVED) ===');
            //console.log('Enhanced data payload:', JSON.stringify(enhancedDataPayload, null, 2));

            this.setState({ isLoading: false });
            this.props.onNext && this.props.onNext(finalPromotionData);
        }, 500); // 1.5 seconds shimmer effect
    }

    handleBack = () => {
        //console.log('=== HANDLING BACK - PRESERVING CURRENT SELECTIONS ===');

        const { branchModuleSelections, targetAcademicYear } = this.state;
        const { promotionData } = this.props;

        // Create preserved promotion data to pass back
        const preservedPromotionData = {
            ...promotionData,
            branchModuleSelections: { ...branchModuleSelections },
            targetAcademicYear,
            preservedAt: new Date().toISOString(),
            navigationHistory: (promotionData.navigationHistory || []).concat(['back-from-module-selection'])
        };

        //console.log('Preserved promotion data for back navigation:', preservedPromotionData.branchModuleSelections);

        this.props.onBack && this.props.onBack(preservedPromotionData);
    }

    getAllSelectedModules = () => {
        const { branchModuleSelections } = this.state;
        const allModules = new Set();

        Object.values(branchModuleSelections).forEach(branchModules => {
            Object.keys(branchModules).forEach(module => {
                if (branchModules[module] === true &&
                    !['branchName', 'boardCount', 'hasBoards'].includes(module)) {
                    allModules.add(this.getModuleDisplayName(module));
                }
            });
        });

        return Array.from(allModules);
    }

    // Get summary of module selections per branch
    getBranchModuleSummary = () => {
        const { branchModuleSelections } = this.state;
        const summary = {};

        Object.keys(branchModuleSelections).forEach(branchId => {
            const branchModules = branchModuleSelections[branchId];
            const selectedModules = [];

            Object.keys(branchModules).forEach(moduleKey => {
                if (branchModules[moduleKey] === true &&
                    !['branchName', 'boardCount', 'hasBoards'].includes(moduleKey)) {
                    selectedModules.push(this.getModuleDisplayName(moduleKey));
                }
            });

            summary[branchId] = {
                branchName: branchModules.branchName,
                selectedModules: selectedModules,
                moduleCount: selectedModules.length,
                hasAllMandatory: branchModules.admissions && branchModules.financeGeneralSettings,
                preservedSelections: true
            };
        });

        return summary;
    }

    handleCancel = () => {
        this.props.onCancel && this.props.onCancel();
    }

    // Toast notification methods
    showSuccess = (message) => {
        this.toast.current.show({ severity: 'success', summary: 'Success', detail: message, life: 3000 });
    }

    showError = (message) => {
        this.toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
    }

    showWarn = (message) => {
        this.toast.current.show({ severity: 'warn', summary: 'Warning', detail: message, life: 3000 });
    }

    render() {
        const { branchModuleSelections, dataPayload, isLoading } = this.state;
        const { promotionData } = this.props;

        const modules = [
            { key: 'admissions', label: 'Admissions', icon: 'pi pi-user-plus', required: true },
            { key: 'financeGeneralSettings', label: 'Finance General Settings', icon: 'pi pi-cog', required: true },
            { key: 'feeSetup', label: 'Fee SetUp', icon: 'pi pi-dollar', required: false },
            { key: 'finance', label: 'Finance', icon: 'pi pi-chart-line', required: false },
            // { key: 'transport', label: 'Transport', icon: 'pi pi-car', required: false },
        ];

        // Get branches from the data payload
        const branches = dataPayload?.branches || promotionData?.selectedBranches || [];

        //console.log('Rendering with branches:', branches);
        //console.log('Current branch module selections (preserved):', branchModuleSelections);

        // Show shimmer effect when loading
        if (isLoading) {
            return (
                <div className="promotion-module-selection p-4">
                    <Toast ref={this.toast} />

                    {/* School Branch Configuration Preview Shimmer */}
                    <Card className="mb-4">
                        <div className="mb-4">
                            <Skeleton width="300px" height="28px" className="mb-3" />
                        </div>

                        {/* Branch Configuration Cards Shimmer */}
                        {[1, 2, 3, 4].map((index) => (
                            <div key={index} className="mb-4 p-4" style={{ border: '1px solid #e0e0e0', borderRadius: '8px' }}>
                                <div className="mb-3">
                                    <Skeleton width="120px" height="24px" className="mb-2" />
                                    <Skeleton width="150px" height="16px" />
                                </div>

                                {/* Module Tags Shimmer */}
                                <div className="flex flex-wrap gap-2">
                                    <Skeleton width="80px" height="32px" borderRadius="16px" />
                                    <Skeleton width="100px" height="32px" borderRadius="16px" />
                                    <Skeleton width="70px" height="32px" borderRadius="16px" />
                                    <Skeleton width="120px" height="32px" borderRadius="16px" />
                                </div>
                            </div>
                        ))}
                    </Card>

                    {/* Action Buttons Shimmer */}
                    <div className="flex justify-content-center gap-3 mt-6">
                        <Skeleton width="286px" height="48px" borderRadius="8px" />
                        <Skeleton width="115px" height="48px" borderRadius="8px" />
                        <Skeleton width="115px" height="48px" borderRadius="8px" />
                    </div>
                </div>
            );
        }

        return (
            <div className="promotion-module-selection p-4">
                <Toast ref={this.toast} />

                {/* Header Information */}
                {/* <Card className="mb-4">
                    <div className="flex justify-content-between align-items-center mb-3">
                        <h3 className="font-bold text-primary mb-0">Module Selection</h3>
                        {promotionData?.preservedSelections && (
                            <div className="flex align-items-center text-green-600">
                                <i className="pi pi-check-circle mr-1"></i>
                                <small>Selections Preserved</small>
                            </div>
                        )}
                    </div>
                    <div className="grid">
                        <div className="col-12 md:col-6">
                            <div className="field">
                                <label className="font-semibold">Source Academic Year:</label>
                                <div className="text-lg">{dataPayload?.academicYear}</div>
                            </div>
                        </div>
                        <div className="col-12 md:col-6">
                            <div className="field">
                                <label className="font-semibold">Target Academic Year:</label>
                                <div className="text-lg text-primary">{dataPayload?.targetAcademicYear}</div>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="field">
                                <label className="font-semibold">Total Branches:</label>
                                <div className="text-lg">{branches.length}</div>
                            </div>
                        </div>
                    </div>
                </Card> */}

                {/* Module Configuration Table */}
                <Card className="mb-4">
                    <h4 className="font-semibold mb-3">Module Configuration</h4>
                    <div className="module-table">
                        {/* Table Header */}
                        <div className="flex border-bottom-2 surface-border pb-3 mb-3">
                            <div className="flex-1 font-semibold text-lg">Module</div>
                            {branches.map(branch => (
                                <div key={branch.branchId} className="flex-1 text-center font-semibold text-lg">
                                    <div>{branch.branchName}</div>
                                    <small className="text-gray-600">
                                        {branch.boardCount} board(s)
                                    </small>
                                </div>
                            ))}
                        </div>

                        {/* Table Rows */}
                        {modules.map(module => (
                            <div key={module.key} className={`flex align-items-center p-3 border-bottom-1 surface-border hover:bg-gray-50 ${module.required ? 'required-module' : ''}`}>
                                <div className="flex-1">
                                    <div className="flex align-items-center">
                                        <i className={`${module.required ? 'text-black-600' : 'text-gray-600'}`}></i>
                                        <span className={`font-medium ${module.required ? 'text-black-700' : ''}`}>
                                            {module.label}
                                            {module.required && (
                                                // <span className="ml-2 text-xs bg-blue-100 text-blue-700 px-2 py-1 border-round">
                                                //     mandatory
                                                // </span>
                                                <span className="ma-required">*</span>
                                            )}
                                        </span>
                                    </div>
                                </div>
                                {branches.map(branch => (
                                    <div key={branch.branchId} className="flex-1 text-center">
                                        <Checkbox
                                            checked={branchModuleSelections[branch.branchId]?.[module.key] || false}
                                            onChange={(e) => this.onModuleChange(branch.branchId, module.key, e.checked)}
                                            disabled={false}
                                            className={`p-checkbox-lg ${module.required ? 'required-checkbox' : ''}`}
                                            style={module.required ? {
                                                opacity: 0.5,
                                                filter: 'grayscale(50%)',
                                                // cursor: 'not-allowed',
                                                accentColor: 'red' // Tailwind blue-500
                                            } : {}}
                                        />
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>

                    {/* Module Summary */}
                    {/*
                    <div className="mt-4 p-3 bg-blue-50 border-radius-md">
                        <div className="flex align-items-center justify-content-between">
                            <div>
                                <h6 className="m-0 text-blue-700 font-semibold">Configuration Summary</h6>
                                <p className="mt-1 mb-0 text-blue-600 text-sm">
                                    Configure modules for each branch individually.
                                    <strong> Admissions and Finance General Settings are required for all promotions.</strong>
                                    {promotionData?.preservedSelections && (
                                        <span className="block mt-1 text-green-700">
                                            ✓ Your previous selections have been preserved during navigation.
                                        </span>
                                    )}
                                </p>
                            </div>
                            <div className="text-blue-700">
                                <i className="pi pi-info-circle text-xl"></i>
                            </div>
                        </div>
                    </div>
                    */}

                </Card>

                {/* Branch Module Summary */}
                {/*
                
                <Card className="mb-4">
                    <h4 className="font-semibold mb-3">Selected Modules Summary</h4>
                    <div className="grid">
                        {branches.map(branch => {
                            const branchModules = branchModuleSelections[branch.branchId];
                            const selectedModules = Object.keys(branchModules || {}).filter(key =>
                                branchModules[key] === true &&
                                !['branchName', 'boardCount', 'hasBoards'].includes(key)
                            ).map(key => this.getModuleDisplayName(key));

                            return (
                                <div key={branch.branchId} className="col-12 md:col-6 lg:col-4">
                                    <div className="border-1 surface-border border-round p-3">
                                        <h5 className="font-semibold text-primary mb-2">{branch.branchName}</h5>
                                        <div className="text-sm text-gray-600 mb-2">
                                            {branch.boardCount} board(s) • {selectedModules.length} module(s)
                                        </div>
                                        <div className="flex flex-wrap gap-1">
                                            {selectedModules.map((module, index) => (
                                                <span key={index} className="bg-blue-100 text-blue-700 px-2 py-1 border-round text-xs">
                                                    {module}
                                                </span>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </Card>
                
                */}

                {/* Action Buttons */}
                <div className="flex justify-content-center gap-3 mt-6">

                    <Button
                        label="Next"
                        // icon="pi pi-arrow-right"
                        iconPos="right"
                        className="p-button"
                        style={{
                            borderRadius: '8px',
                            padding: '12px 24px',
                            fontSize: '14px',
                            fontWeight: '600',
                            backgroundColor: '#3B82F6',
                            border: 'none',
                            color: '#ffffff',
                            minWidth: '286px'
                        }}
                        onClick={this.handleNext}
                        disabled={isLoading}
                    />
                    <Button
                        label="Back"
                        // icon="pi pi-arrow-left"
                        className="p-button-outlined"
                        style={{
                            borderRadius: '8px',
                            padding: '12px 24px',
                            fontSize: '14px',
                            fontWeight: '600',
                            border: '0px solid #3B82F6',
                            color: 'black',
                            backgroundColor: '#F4F5F6',
                            minWidth: '115px'
                        }}
                        onClick={this.handleBack}
                        disabled={isLoading}
                    />

                    <Button
                        label="Cancel"
                        // icon="pi pi-times"
                        className="p-button-outlined"
                        style={{
                            borderRadius: '8px',
                            padding: '12px 24px',
                            fontSize: '14px',
                            fontWeight: '600',
                            border: '0px solid #E5E7EB',
                            color: 'black',
                            backgroundColor: '#F4F5F6',
                            minWidth: '115px'
                        }}
                        onClick={this.handleCancel}
                        disabled={isLoading}
                    />

                </div>
            </div>
        );
    }
}

export default PromotionModuleSelection;